export default {
	firestorePath: "rewards",
	firestoreRefType: "collection",
	moduleName: "rewards",
	statePropName: "data",
	namespaced: true,
	state: {},
	getters: {},
	sync: {
		defaultValues: {
			status: "published"
		}
	},
	serverChange: {
	},
	mutations: {},
	actions: {
	},
};
